'use client'

import React, { useState } from 'react'
import Link from 'next/link'
import { MediaHeroIntro } from './reveal'
import { TourCoach, type CoachStep } from './TourCoach'

// Hero background (design-phase asset; can later be set per-development via the heroImage media field).
export const HERO_IMG = '/hero-keary-27.jpg'

export type DeckConfig = {
  eyebrow: string
  headline: string
  heroLeadPhrases: string[]
  heroEmphasize?: number[]
  checklistHref: string
  checklistLabel: string
  coachSteps: CoachStep[] // the "how does this work?" guided tour
}

// Onboarding hero — leads with the checklist CTA (decisive users are one tap away). The secondary
// "First — how does this work?" launches an app-style guided tour that spotlights the nav.
export function StepDeck({ config, heroImg }: { config: DeckConfig; heroImg?: string }) {
  const [tour, setTour] = useState(false)

  return (
    <div className="deck">
      <div className="deck__track">
        <section className="deck__slide deck__hero is-active">
          {heroImg ? <img className="deck__bg" src={heroImg} alt="" /> : null}
          <div className="deck__overlay" />
          <div className="deck__content">
            <div className="deck__col">
              <MediaHeroIntro
                eyebrow={config.eyebrow}
                headline={config.headline}
                leadPhrases={config.heroLeadPhrases}
                emphasizeLead={config.heroEmphasize}
                actions={
                  <>
                    <Link className="btn btn-light" href={config.checklistHref}>
                      {config.checklistLabel}
                    </Link>
                    <button className="btn btn-ghost-light" onClick={() => setTour(true)}>
                      First — how does this work?
                    </button>
                  </>
                }
              />
            </div>
          </div>
        </section>
      </div>

      {tour ? (
        <TourCoach
          config={{
            steps: config.coachSteps,
            ctaHref: config.checklistHref,
            ctaLabel: config.checklistLabel,
          }}
          onClose={() => setTour(false)}
        />
      ) : null}
    </div>
  )
}
